import type { CSSProperties } from "react";
import * as styled from "styled-components";

export const MOBILE_BREAKPOINT = 768; // px, matches antd's `md` breakpoint

// Row that wraps normally on desktop; below the breakpoint it switches to a
// full-width vertical stack, so every direct child becomes its own block.
export const StackRow = styled.default.div<{
  $gap?: number;
  $align?: string;
  $justify?: string;
}>`
  display: flex;
  flex-wrap: wrap;
  align-items: ${(p) => p.$align ?? "center"};
  justify-content: ${(p) => p.$justify ?? "space-between"};
  gap: ${(p) => p.$gap ?? 8}px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    align-items: stretch;

    & > * {
      width: 100%;
      margin: 0 !important;
    }
  }
`;

export const wrapText: CSSProperties = {
  wordBreak: "break-word",
  overflowWrap: "break-word",
};
